export default __webpack_public_path__ + "static/media/payment-safe.88301a10.png";